export default __webpack_public_path__ + "static/media/gallery_two.d42f516a.jpg";